/**
 * useTheme Hook
 * Custom hook for accessing theme context
 */

import { useTheme as useThemeContext } from "@/context/ThemeContext"

export function useTheme() {
  return useThemeContext()
}
